import React, { Component } from 'react';
import { BrowserRouter, Route, Routes, Navigate  } from "react-router-dom";
import Cookies from 'universal-cookie'
import Login from '../components/login/login'
import Inicio from '../components/view/inicio'
// Procesos
import VentaEESS from '../components/view/procesos/ventaEESS'
import Volumetrico from '../components/view/procesos/volumetrico';

//Reportes
import CVolumetrico from '../components/view/consultas/volumetrico';

const cookies = new Cookies()

export default class route extends Component {

    state ={
        estadoToken: false
    }

    accederLogin = (estadoToken) =>{
        this.setState({estadoToken})
    }

  render() {
    return (
        <BrowserRouter>
            <Routes>
                {
                    !this.state.estadoToken && !cookies.get('status')
                        ?   <Route path="/" element={<Login accederLogin={this.accederLogin}/>}/>
                        :   
                        <>
                            <Route path="/" element={<Inicio accederLogin={this.accederLogin}/>}/>
                            {
                                (atob(localStorage.getItem('type')) === '0')
                                    ?   <Route path="/ProcesoVentaEESS" element={ <VentaEESS accederLogin={this.accederLogin}/>}/>
                                    :   null
                            }
                            <Route path="/ProcesoVolumetrico" element={ <Volumetrico accederLogin={this.accederLogin}/>}/>
                            <Route path="/ConsultaVolumetrico" element={ <CVolumetrico accederLogin={this.accederLogin}/>}/>
                            <Route path="*" element={<Inicio to="/" replace />} />
                        </>
                }
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    )
  }
}
